import { Card } from '@mui/material';
import { Stack } from '@mui/system';
import { useSelector } from 'react-redux';
import { UNIT } from 'utils/StringDefinition';
import RowTextComponent from '../share-components/RowText';
import SectionTitle, { SectionTitleSub } from '../share-components/Tilte';

const Block0303 = ({ content }) => {
    const sheetData = useSelector((state) => state.sheet.dataSection);
    const blockData = sheetData?.data?.tool002version100?.[`block003`];

    return (
        <Card
            elevation={3}
            component="main"
            sx={{
                width: '100%',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                padding: '0px 16px 16px 16px',
            }}
        >
            <Stack sx={{ width: '100%' }} spacing={0.25}>
                <SectionTitle title="各照査事項" />
                <SectionTitleSub title="① アンカーボルトの応力度照査" />
                <RowTextComponent description="1) 面直角方向 (橋軸)"></RowTextComponent>
                <RowTextComponent
                    paddingLeftFit={3}
                    description=" ・引張応力度"
                    isEqualTo={true}
                    physicSymbolLeft={{ normalText: 'σt' }}
                    valueLeft={blockData?._G147?.value}
                    tooltipLeft={blockData?._G147?.toolTip}
                    unit={UNIT.Nmm2}
                    mathSymbol={blockData?._I147?.value}
                    physicSymbolRight={{ normalText: 'σa' }}
                    valueRight={blockData?._K147?.value}
                    tooltipRight={blockData?._K147?.toolTip}
                    status={blockData?._S147?.value}
                ></RowTextComponent>

                <RowTextComponent
                    paddingLeftFit={3}
                    description=" ・せん断応力度"
                    isEqualTo={true}
                    physicSymbolLeft={{ normalText: 'τt' }}
                    valueLeft={blockData?._G148?.value}
                    tooltipLeft={blockData?._G148?.toolTip}
                    unit={UNIT.Nmm2}
                    mathSymbol={blockData?._I148?.value}
                    physicSymbolRight={{ normalText: 'τa' }}
                    valueRight={blockData?._K148?.value}
                    tooltipRight={blockData?._K148?.toolTip}
                    status={blockData?._S148?.value}
                ></RowTextComponent>

                <RowTextComponent
                    paddingLeftFit={3}
                    description=" ・合成応力度"
                    isEqualTo={false}
                    unit={UNIT.hidden}
                    valueLeft={blockData?._G149?.value}
                    tooltipLeft={blockData?._G149?.toolTip}
                    mathSymbol={blockData?._I149?.value}
                    valueRight={blockData?._K149?.value}
                    tooltipRight={blockData?._K149?.toolTip}
                    status={blockData?._S149?.value}
                ></RowTextComponent>

                <RowTextComponent description="2) 面方向 (橋軸直角)"></RowTextComponent>
                <RowTextComponent
                    paddingLeftFit={3}
                    description="・引張応力度"
                    isEqualTo={true}
                    physicSymbolLeft={{ normalText: 'σt' }}
                    valueLeft={blockData?._G152?.value}
                    tooltipLeft={blockData?._G152?.toolTip}
                    unit={UNIT.Nmm2}
                    mathSymbol={blockData?._I152?.value}
                    physicSymbolRight={{ normalText: 'σa' }}
                    valueRight={blockData?._K152?.value}
                    tooltipRight={blockData?._K152?.toolTip}
                    status={blockData?._S152?.value}
                ></RowTextComponent>

                <RowTextComponent
                    paddingLeftFit={3}
                    description=" ・せん断応力度"
                    isEqualTo={true}
                    physicSymbolLeft={{ normalText: 'τt' }}
                    valueLeft={blockData?._G153?.value}
                    tooltipLeft={blockData?._G153?.toolTip}
                    unit={UNIT.Nmm2}
                    mathSymbol={blockData?._I153?.value}
                    physicSymbolRight={{ normalText: 'τa' }}
                    valueRight={blockData?._K153?.value}
                    tooltipRight={blockData?._K153?.toolTip}
                    status={blockData?._S153?.value}
                ></RowTextComponent>

                <RowTextComponent
                    paddingLeftFit={3}
                    description=" ・合成応力度"
                    isEqualTo={false}
                    unit={UNIT.hidden}
                    valueLeft={blockData?._G154?.value}
                    tooltipLeft={blockData?._G154?.toolTip}
                    mathSymbol={blockData?._I154?.value}
                    valueRight={blockData?._K154?.value}
                    tooltipRight={blockData?._K154?.toolTip}
                    status={blockData?._S154?.value}
                ></RowTextComponent>
            </Stack>
        </Card>
    );
};

export default Block0303;
